<template>
  <div class="builder__swatch-option">
    <div class="builder__swatch-option-name-and-current-choice">
      <div class="builder__swatch-option-name">
        {{ (option.is_embroidery_grouped ? (option.display_title ? option.display_title : option.title) : 'Color')
         + (option.max_select > 1 ? ' (Select up to ' + maxSelect + ')' : '') }}:
      </div>
      <div class="builder__swatch-option-current-choice">
        {{ chosenLabel }}
      </div>
    </div>
    <div class="builder__swatch-option-choices">
      <div v-for="choice in option.choices" class="builder__swatch-option-choice">
        <input type="radio"
               class="builder__swatch-option-choice-input"
               :id="domId(choice.id)"
               :value="choice.id"
               v-model="selection"
               @click="radioClickHandler"
        >
        <input type="checkbox"
               class="builder__swatch-option-choice-input"
               v-if="selected(choice.id)"
               checked
        >
        <label class="builder__swatch-option-choice-label" :for="domId(choice.id)">
          <span class="builder__swatch-option-choice-label-swatch">
            <img class="builder__swatch-option-choice-label-swatch-image"
                 :src="choice.custom_builder_swatch_image_src"
                 alt=""
            >
          </span>
          <!--span class="builder__swatch-option-choice-label-text">{{ choice.title }}</span-->
        </label>
      </div>
    </div>

    <div v-if="!option.is_required" class="builder__swatch-option-none-choice">
      <input type="radio"
             class="builder__swatch-option-none-choice-input"
             :id="domId('none')"
             :value="null"
             v-model="selection"
      >
      <label class="builder__swatch-option-none-choice-label" :for="domId('none')">
        <span class="builder__swatch-option-none-choice-label-text">{{ noneLabel }}</span>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'builder-option-swatch',
    props: ['option'],

    methods: {
      deselect(choiceId) {
        //HACK deselect by setting to what you want to remove? madness!
        // see selection.set, below, for details
        this.selection = choiceId
      },
      domId(suffix) {
        return 'product-step-option-' + this.option.id + '-' + suffix
      },
      radioClickHandler(e) {
        //Allow to deselect the only selected radio button
        //if (this.selected(e.target.value)) {
        //  this.deselect(e.target.value)
        //}
      },
      selected(choiceId) {
        //HACK omg, srsly - the worst of the hack is in the v-if checkbox, above
        let valuesArray = this.option.selected_value ? this.option.selected_value.split(',') : []
        return valuesArray.includes(choiceId)
      },
    },

    computed: {
      chosenLabel() {
        let choice = this.option.choices.filter(c => this.selected(c.id))
        return choice.length
          ? choice.reduce((accumulator, item) => accumulator + (accumulator.length ? ', ' : '') + item.title, '')
          : this.noneLabel;
      },

      chosenChoiceIndexes() {
        let retval = []
        if (this.option.selected_value) {
          const valuesArray = this.option.selected_value.split(',')
          valuesArray.forEach(choiceId => {
            retval.push(this.option.choices.findIndex(c => c.id === choiceId))
          }, this)
        }
        return retval
      },

      maxSelect() {
        let retval
        switch (parseInt(this.option.max_select, 10)) {
          case 1:
            retval = 'one'
          break
          case 2:
            retval = 'two'
          break
          case 3:
            retval = 'three'
          break
          case 4:
            retval = 'four'
          break
          case 5:
            retval = 'five'
          break
          case 6:
            retval = 'six'
          break
          case 7:
            retval = 'seven'
          break
          case 8:
            retval = 'eight'
          break
          case 9:
            retval = 'nine'
          break
          case 10:
            retval = 'ten'
          break
          case 11:
            retval = 'eleven'
          break
          case 12:
            retval = 'twelve'
          break
          default:
            retval = this.option.max_select
        }
        return retval
      },

      noneLabel() {
        return this.option.swatch_none_label ? this.option.swatch_none_label : 'None'
      },

      selection: {
        get() { return this.option.selected_value },
        set(newValue) {
          if (this.option.max_select < 2 || newValue === null) {
            this.$emit('input', newValue)
          } else {
            //HACK this subverts the intent of a setter a bit
            let valuesArray = this.option.selected_value ? this.option.selected_value.split(',') : []
            const index = valuesArray.findIndex(value => value === newValue)
            if (index >= 0) {
              //they clicked a selected option, de-select it
              valuesArray.splice(index, 1)
            } else if (valuesArray.length >= this.option.max_select) {
              //we're already full
              alert('All slots full, de-select a selected color to add a different one.')
            } else {
              valuesArray.push(newValue)
            }
            this.$emit('input', valuesArray.join(','))
          }
        },
      },

    },
  }
</script>



// WEBPACK FOOTER //
// Swatch.vue?a52b0ef0